import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { reverse, sortBy } from 'lodash';
import { load } from './api';
import { CORPORATE_LEAD_NEW } from '../../Routes';
import { useSelector } from 'react-redux';
import { Show } from '../../components';

const formatDate = (d) => moment(d).format('DD/MM/YYYY HH:mm');

const List = () => {
  const [state, setState] = useState({ loading: true, data: [] });
  const authorities = useSelector((state) => state?.auth?.authorities?.map(e => e.authority));

  useEffect(() => {
    load().then((res) =>
      setState((prevState) => ({
        ...prevState,
        data: reverse(sortBy(res.data, ['createdDate'])),
        loading: false,
      })),
    );
  }, []);

  return (
    <div className='mx-5 mt-5'>
      <Show if={authorities?.includes('ROLE_BANKSTAFF')}>
        <div className='mb-1'>
          <Link to={CORPORATE_LEAD_NEW} className='btn btn-primary'>
            Tạo mới
          </Link>
        </div>
      </Show>

      <table className='table'>
        <thead>
        <tr className='bg-secondary text-white'>
          <th className='align-top'>Mã tham chiếu</th>
          <th className='align-top'>Tên doanh nghiệp</th>
          <th className='align-top'>Mã số thuế</th>
          <th className='align-top'>Ngày giới thiệu</th>
          <th className='align-top'>Trạng thái</th>
        </tr>
        </thead>
        <tbody>
        {state?.data?.length ? (
          state?.data?.map((d) => (
            <tr key={d.seq}>
              <td>
                <Link to={`/corporate-leads/view/${d.seq}`}>{d.refNo}</Link>
              </td>
              <td>{d.companyName}</td>
              <td>{d.taxCode}</td>
              <td>{formatDate(d.createdDate)}</td>
              <td>
                {d.draft ? 'Nháp' : d.agentCode ? 'FSC đang tư vấn' : d.employeeCode ? 'Chờ DOB phân bổ cho FSC' : ''}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={3} className='text-center'>
              Không tìm thấy dữ liệu
            </td>
          </tr>
        )}
        </tbody>
      </table>
    </div>
  );
};

export default List;
